import { Directive, ElementRef, Input, AfterViewInit, PLATFORM_ID, inject } from '@angular/core';
import { isPlatformServer } from '@angular/common';

import { findFirstFocusableElement } from '@fcom/ui-components/utils/dom.utils';

@Directive({
  selector: '[finFocus]',
  standalone: false,
})
export class FocusDirective implements AfterViewInit {
  private elementRef = inject(ElementRef);
  private platform = inject(PLATFORM_ID);

  @Input() autofocus = false;

  ngAfterViewInit(): void {
    if (isPlatformServer(this.platform)) {
      return;
    }

    if (this.autofocus) {
      this.elementRef.nativeElement.focus?.() || findFirstFocusableElement(this.elementRef.nativeElement)?.focus();
    }
  }
}
